var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('one-card')],1),_c('div',{staticClass:"col-md-4"},[_c('reputation-score')],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }